export enum PlanTypes {
  PREMIUM = "Premium",
  STARTER = "Starter",
}

export const FREE_PLAN_SUBSCRIPTION = 100;
export const PREMIUM_PLAN_SUBSCRIPTION = 101;

export const paymentPlans = [
  {
    id: FREE_PLAN_SUBSCRIPTION,
    title: PlanTypes.STARTER,
    details: [
      { benefit: "Bite-sized Learning", isEnabled: true, isBold: false },
      { benefit: "Account Connectivity", isEnabled: true, isBold: false },
      {
        benefit: "Spending Tracker & Budget Simulator",
        isEnabled: true,
        isBold: false,
      },
      {
        benefit: "Debt Management Calculator",
        isEnabled: false,
        isBold: false,
      },
      { benefit: "Retirement Projector", isEnabled: false, isBold: false },
      { benefit: "Net Worth Monitor", isEnabled: false, isBold: false },
      {
        benefit: "One-on-One Money Mentorship™",
        isEnabled: false,
        isBold: true,
      },
    ],
    price: "0.00",
    period: "Forever",
    periodDetails: "",
  },
  {
    id: PREMIUM_PLAN_SUBSCRIPTION,
    title: PlanTypes.PREMIUM,
    details: [
      { benefit: "Bite-sized Learning", isEnabled: true, isBold: false },
      { benefit: "Account Connectivity", isEnabled: true, isBold: false },
      {
        benefit: "Spending Tracker & Budget Simulator",
        isEnabled: true,
        isBold: false,
      },
      { benefit: "Debt Management Calculator", isEnabled: true, isBold: false },
      { benefit: "Retirement Projector", isEnabled: true, isBold: false },
      { benefit: "Net Worth Monitor", isEnabled: true, isBold: false },
      {
        benefit: "One-on-One Money Mentorship™",
        isEnabled: true,
        isBold: true,
      },
    ],
    price: "9.99",
    period: "Billed Monthly",
    periodDetails: "After your 7 day free trial",
  },
];
